import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'
import MenuItem from 'material-ui/MenuItem'
import AppBar from 'material-ui/AppBar'
import Drawer from 'material-ui/Drawer'
import FlatButton from 'material-ui/FlatButton'

import { logOut } from '../actions/users.js'

class Navigator extends Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  handleToggle = () => this.setState({ open: !this.state.open })
  handleClose = () => this.setState({ open: false })

  handleLogout = () => {
    const { dispatch } = this.props
    dispatch(logOut())
  }

  render() {
    const isAuthenticated = this.props.token

    let role = this.props.role
    let hasAccessToEvents = isAuthenticated && role.length > 0 && role.charAt(0) != '0'
    let hasAccessToUsers = isAuthenticated && role.length > 1 && role.charAt(1) != '0'
    let hasAccessToReports = isAuthenticated && role.length > 2 && role.charAt(2) != '0'
    let hasAccessToBuildings = isAuthenticated && role.length > 3 && role.charAt(3) != '0'
    let hasAccessToCompanies = isAuthenticated && role.length > 4 && role.charAt(4) != '0'
    let hasAccessToLocations = isAuthenticated && role.length > 5 && role.charAt(5) != '0'
    let hasAccessToClusters = isAuthenticated && role.length > 6 && role.charAt(6) != '0'

    var topBar = (
      <AppBar
        title='Better Spaces'
        onLeftIconButtonTouchTap={this.handleToggle}
        onRightIconButtonTouchTap={this.handleLogout}
        iconElementRight={<FlatButton label='Logout' />}
      />
    )

    if (!isAuthenticated) {
      topBar = <AppBar title='Better Spaces' iconElementLeft={<div />} />
    }

    return (
      <div>
        {topBar}

        <Drawer
          docked={false}
          width={200}
          open={this.state.open}
          containerStyle={{ height: 'calc(100% - 64px)', top: 64 }}
          onRequestChange={open => this.setState({ open })}>
          <MenuItem
            onClick={this.handleClose}
            containerElement={hasAccessToEvents ? <Link to='/events' /> : <Link to='/accessDenied' />}>
            Events
          </MenuItem>
          <MenuItem
            onClick={this.handleClose}
            containerElement={hasAccessToCompanies ? <Link to='/companies' /> : <Link to='/accessDenied' />}>
            Companies
          </MenuItem>
          <MenuItem
            onClick={this.handleClose}
            containerElement={hasAccessToBuildings ? <Link to='/buildings' /> : <Link to='/accessDenied' />}>
            Buildings
          </MenuItem>
          <MenuItem
            onClick={this.handleClose}
            containerElement={hasAccessToClusters ? <Link to='/clusters' /> : <Link to='/accessDenied' />}>
            Clusters
          </MenuItem>
          <MenuItem
            onClick={this.handleClose}
            containerElement={hasAccessToLocations ? <Link to='/locations' /> : <Link to='/accessDenied' />}>
            Locations
          </MenuItem>
          <MenuItem
            onClick={this.handleClose}
            containerElement={hasAccessToUsers ? <Link to='/users' /> : <Link to='/accessDenied' />}>
            Users
          </MenuItem>
          <MenuItem
            onClick={this.handleClose}
            containerElement={hasAccessToReports ? <Link to='/reports' /> : <Link to='/accessDenied' />}>
            Reports
          </MenuItem>
        </Drawer>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    token: state.usersReducer.token,
    role: state.usersReducer.role
  }
}

export default connect(mapStateToProps)(Navigator)



// WEBPACK FOOTER //
// ./src/containers/Navigator.js